import PropTypes from "prop-types";

// material-ui
import { Box, Grid } from "@mui/material";
import AddchartIcon from "@mui/icons-material/Addchart";

// project
import AuthCard from "@/pages/authentication/AuthCard";

// ========|| Authentication - Wrapper||========

const AuthWrapper = ({ children }) => (
    <Box sx={{ minHeight: "100vh" }}>
        <Grid
            container
            direction="column"
            justifyContent="flex-end"
            sx={{
                minHeight: "100vh",
            }}
        >
            <Grid item xs={12} sx={{ ml: 3, mt: 3 }}>
                Strategic Organization Development Dashboard
            </Grid>

            <Grid item xs={12}>
                <Grid
                    item
                    xs={12}
                    container
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        minHeight: {
                            xs: "calc(100vh - 134px)",
                            md: "calc(100vh - 112px)",
                        },
                    }}
                >
                    <Grid item>
                        <AuthCard>{children}</AuthCard>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
                {/**
                Here Auth Footer
                 */}
            </Grid>
        </Grid>
    </Box>
);

AuthWrapper.propTypes = {
    children: PropTypes.node,
};

export default AuthWrapper;
